import UserStatus from 'aa/vue/models/UserStatus';

export function getSelectedPlanFromSession() {
    try {
        const selectedPlan = JSON.parse(sessionStorage.getItem('selectedPlan'));
        if (selectedPlan) {
            return selectedPlan;
        }
    } catch (error) {
        console.error(error, 'Could not retrieve selected plan from Session Storage');
    }
    return null;
}

export function getPackageInSessionOrUserPackage(svodUserPackage) {
    try {
        const selectedPlanTier = JSON.parse(sessionStorage.getItem('planTier'));
        const selectedPlanType = JSON.parse(sessionStorage.getItem('planType'));

        if (
            //selectedPlanTier could be 0, so we need to check for falsy values
            (!selectedPlanTier &&
                typeof selectedPlanTier !== 'number' &&
                typeof selectedPlanTier !== 'string') ||
            !selectedPlanType
        ) {
            console.error(
                'Either planTier or planType is missing in Session Storage, using user package',
            );
            return svodUserPackage;
        }

        return {
            plan_tier: selectedPlanTier,
            plan_type: selectedPlanType,
        };
    } catch (error) {
        console.error(error, 'Could not retrieve plan details from Session Storage');
        return svodUserPackage;
    }
}

const ERROR_TRACKING_PAGE_TYPE = 'switchplan_directLink_error';
const GENERIC_ERROR = 'GenericError';
const GENERIC_ERROR_HEADING = 'oops_something_went_wrong';
const GENERIC_ERROR_SUBHEADING = 'direct_link_general_error';
export const getGenericErrorParams = (subheading = []) => ({
    name: GENERIC_ERROR,
    params: {
        heading: GENERIC_ERROR_HEADING,
        subHeading: [GENERIC_ERROR_SUBHEADING, ...subheading],
        errorTrackingPageType: ERROR_TRACKING_PAGE_TYPE,
    },
});

export function directLinkSPChecks(to, store, serverData) {
    if (to.query && to.query.redirect_error) {
        return { error: getGenericErrorParams() };
    }

    if (!to.query || !to.query.tier || !to.query.cadence) {
        return { error: getGenericErrorParams(['dl_error_plan_unavailable']) };
    }

    const onTrial = serverData.user.svod.user_package.on_trial;
    if (onTrial) {
        return { error: getGenericErrorParams(['dl_error_free_trial']) };
    }

    const isTierNumeric = !isNaN(parseInt(to.query.tier));
    const plans = serverData.plans;
    const plan = plans.find((p) => {
        const planTypeMatch = p.planType === to.query.cadence;
        if (!planTypeMatch) {
            return false;
        }
        if (isTierNumeric) {
            return p.tier === parseInt(to.query.tier);
        }
        return p.planTier === to.query.tier;
    });

    if (!plan) {
        return { error: getGenericErrorParams(['dl_error_plan_unavailable']) };
    }

    // Check if the DirectLink plan is the same as the user's plan (needed for future US implementation)
    const currentUserPackage = serverData?.user?.svod?.user_package;
    if (
        ((!isTierNumeric && plan.planTier == currentUserPackage?.plan_tier) ||
            (isTierNumeric && plan.tier == currentUserPackage?.product_tier)) &&
        plan.planType == currentUserPackage?.plan_type
    ) {
        return { error: getGenericErrorParams(['dl_error_plan_unavailable']) };
    }

    const userStatus = store.getters['user/getUserPackageStatus'];

    if (userStatus === UserStatus.STATUS_CANCEL_SCHEDULED) {
        return { error: getGenericErrorParams(['dl_error_active_cancel_state']) };
    }

    const subscriptionStatus = serverData.subscriptionStatus || {};
    if (
        subscriptionStatus.scheduled_for_cancellation ||
        subscriptionStatus.scheduled_for_downgrade
    ) {
        return { error: getGenericErrorParams(['dl_error_pending']) };
    }

    const currentSubscription = serverData.currentSubscription;
    const pending_sub_found =
        currentSubscription &&
        currentSubscription?.pending_sub &&
        currentSubscription.pending_sub?.planCode !== currentSubscription.user_plan?.planCode;
    if (pending_sub_found) {
        return { error: getGenericErrorParams(['dl_error_pending']) };
    }

    const coupon = serverData.currentSubscription.coupon;

    if (
        coupon &&
        (coupon.discountType === 'free_trial' || coupon.discount?.type === 'free_trial')
    ) {
        return { error: getGenericErrorParams(['dl_error_free_trial']) };
    }

    if (
        coupon &&
        ((coupon.discountType === 'percent' && coupon.discountPercent === 100) ||
            (coupon.discount?.type === 'percent' && coupon.discount?.percent === 100))
    ) {
        return { error: getGenericErrorParams(['dl_error_100']) };
    }

    const products = serverData.products;
    if (products && to.query.cadence in products) {
        const product = products[to.query.cadence].find((item) => item.plan_tier === plan.planTier);
        if (product && !product.allowed_migration) {
            return { error: getGenericErrorParams(['dl_error_plan_unavailable']) };
        }
    }

    return { error: false, plan };
}
